import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useShoppingCartsContext } from 'context/ShoppingCartsContext';

import useTranslation from 'hooks/useTranslation';
import EntityType from 'types/ShoppingCart/EntityType';

interface IProps {
	id: string | null;
	entityType: EntityType;
}

const BtnShoppingCart = (props: IProps) => {
	const { t } = useTranslation();
	const carts = useShoppingCartsContext();

	return (
		<button
			type="button"
			style={{ width: '2.5rem', height: '2.5rem', fontSize: '0.8rem' }}
			className="btn btn-outline-primary"
			onClick={() => carts.openModal(props.id, props.entityType)}
		>
			<FontAwesomeIcon icon={faShoppingCart} />
		</button>
	);
};

export default BtnShoppingCart;
